import { getOmpSearchString } from "@src/api/main/OMPTypes";
import { storePlacesApi, type ApiStorePlaceData } from "../../../../../../api/storePlaces";

/** Результат поиска ячейки места хранения по скану. */
export type StorePlaceCellScanResult =
    | { type: "notFound" }
    | { type: "single"; cell: ApiStorePlaceData }
    | { type: "ambiguous"; cells: ApiStorePlaceData[] };

/**
 * Ищет конечную ячейку склада по отсканированному номеру объекта. \
 * `storePlaces.loadByFilter`: `SoNum` + `OnlyEndPoints: true` + `DivisionCode` склада ПО. \
 * Рекомендации справочные — размещать можно в любую конечную ячейку подразделения.
 * @param barcode отсканированное значение
 * @param divisionCode код склада ПО
 * @returns результат разрешения скана в ячейку
 */
export async function resolveStorePlaceCellScan(barcode: string, divisionCode: number): Promise<StorePlaceCellScanResult> {
    const soNum = getOmpSearchString(barcode, { cs: "case_dependent" });

    if (soNum == null || !isValidCode(divisionCode)) {
        return { type: "notFound" };
    }

    const cells = await storePlacesApi.load({
        filter: {
            SoNum: soNum,
            DivisionCode: divisionCode,
            OnlyEndPoints: true,
        },
    });

    if (cells.length === 0) {
        return { type: "notFound" };
    }

    if (cells.length === 1) {
        return { type: "single", cell: cells[0] };
    }

    return { type: "ambiguous", cells };
}

function isValidCode(code: number): boolean {
    return code !== 0;
}
